const RECEIVE_DASHBOARD = '/dashboard/RECEIVE_DASHBOARD';

export default {
    RECEIVE_DASHBOARD,
};
